import { skills } from "../../data/resume";

function Technologies() {
    return (
        <section id="skills" className="section">
            <div className="container">
                <div className="section-header">
                    <p className="section-eyebrow">What I work with</p>
                    <h2 className="section-title">Skills</h2>
                </div>
                <div className="skills-grid">
                    {skills.map((group) => (
                        <div className="skill-card" key={group.category}>
                            <h3>{group.category}</h3>
                            <div className="badge-row">
                                {group.items.map((item) => (
                                    <span className="badge-pill" key={item}>{item}</span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Technologies;
